// extracted by mini-css-extract-plugin
module.exports = {"eco-flash-sale-box":"content_eco-flash-sale-box__5qxpa"};